import { SeatDetails } from "features/types";
import { useQuery } from "@tanstack/react-query";
import { get } from "services/http";

export interface SectionRowDetails {
  section: string;
  sectionDisplay: string;
  row: string;
  rowDisplay: string;
  ga: boolean;
}

interface FindSeatsBySectionAndRowRequest {
  venueId: number;
  section?: string;
  row?: string;
  eventTypeName: string;
}

export const findSeatsBySectionAndRowRequest = (
  params: FindSeatsBySectionAndRowRequest
) => {
  const { venueId, ...otherParams } = params;
  return get<SeatDetails[]>({
    url: `/venues/${venueId}/tenant/seats`,
    params: otherParams,
  });
};

interface FindSeatsBySectionRequest {
  venueId: number;
  section: string;
  eventTypeName: string;
}

export const findSeatsBySectionRequest = (params: FindSeatsBySectionRequest) => {
  const { venueId, ...otherParams } = params;
  return get<Record<string, SeatDetails[]>>({
    url: `/venues/${venueId}/tenant/seatsBySection`,
    params: otherParams,
  });
};

export const useFetchSeatsBySectionQuery = (
  venueId: number | undefined,
  section: string | undefined,
  eventTypeName: string | undefined
) => {
  return useQuery(
    ["fetchSeatsBySection", venueId, section, eventTypeName],
    () =>
      findSeatsBySectionRequest({
        venueId: venueId!,
        section: section!,
        eventTypeName: eventTypeName!,
      }),
    {
      staleTime: 0,
      enabled: !!venueId && !!section && !!eventTypeName,
    }
  );
};
